$(document).ready(function(){
    $("#navbarDropdown").on('shown.bs.dropdown', function(){
        $(this).find('#search').focus();
        $(this).find('#search').addClass("test");
    });
});